"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SchemaDisplay = void 0;
var core_ui_1 = require("@newfront-insurance/core-ui");
var react_1 = __importDefault(require("react"));
// eslint-disable-next-line import/no-cycle
var group_1 = require("./group");
function SchemaDisplay(props) {
    var _a;
    var name = props.name, schema = props.schema, values = props.values;
    return (react_1.default.createElement("div", { "data-testid": "SchemaDisplay-" + name },
        react_1.default.createElement(core_ui_1.Flexbox, { gap: 32, flexDirection: "column" }, (_a = schema.layout) === null || _a === void 0 ? void 0 : _a.map(function (group, ind) { return (react_1.default.createElement(group_1.SchemaDisplayGroup, { key: name + "-SchemaDisplayGroup-item-identifier-" + (ind + 1), name: name, schema: schema, values: values, group: group })); }))));
}
exports.SchemaDisplay = SchemaDisplay;
